import React from "react";

const FourIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="58" height="132">
    <text
      data-name="4"
      transform="translate(0 105)"
      fill="#555"
      fontSize="100"
      fontFamily="Roboto-Bold,Roboto"
      fontWeight="700"
    >
      <tspan x="0" y="0">
        4
      </tspan>
    </text>
  </svg>
);

export default FourIcon;
